// extracted by mini-css-extract-plugin
export default {"initials":"MiniMapNode_initials__Kuzb3"};